import { createFileRoute, Outlet } from '@tanstack/react-router';
import ReportsLayout from '@/app/reports/layout';

export const Route = createFileRoute('/reports')({
  component: RouteLayout,
});

function RouteLayout() {
  return (
    <ReportsLayout>
      <Outlet />
    </ReportsLayout>
  );
}
